import { FormattedMessage } from 'react-intl';
import React from 'react';
import { TransactionInfoDetailsProps } from './TransactionInfoDetails';

type TransactionInfoMessageProps = Pick<
  TransactionInfoDetailsProps,
  'labelType' | 'values'
>;

export default function TransactionInfoMessage({
  labelType
}: TransactionInfoMessageProps) {

  return (
    <FormattedMessage
      id={`transaction-info.${labelType}.body`}
    />
  );
}
